import { API } from './services/typings';
import { Module ,hasModuleAccess} from './pages/RoleList/permissionUtils';



export default function access(initialState: { user?: API.User | undefined, settings?: API.ConfigEntry[] }) {
  const { user } = initialState || {};
  const onlyAdminAccessLogsValue = initialState?.settings?.find((entry) => entry.key === 'ONLY_ADMIN_ACCESS_LOGS')?.value;
  const onlyAdminAccessLogs = onlyAdminAccessLogsValue === 'Y' || onlyAdminAccessLogsValue === 'TRUE';

  // Administrators have all permissions
  const isAdmin = user && user.is_admin === true;

  // Get user's permission list
  const roles = user?.admin_roles;

  // Check if user has either user group or device group permissions (for displaying Groups parent menu)
  const canAccessGroups = isAdmin ||
    hasModuleAccess(roles, Module.USER_GROUPS) ||
    hasModuleAccess(roles, Module.DEVICE_GROUPS);

  // Check if user has either admin roles or control roles
  const canAccessRoles = isAdmin || hasModuleAccess(roles, Module.CONTROL_ROLES);

  return {
    // Basic permissions
    canAdmin: isAdmin,

    // Role-based access control
    canAccessUsers: isAdmin || hasModuleAccess(roles, Module.USERS),
    canAccessUserGroups: isAdmin || hasModuleAccess(roles, Module.USER_GROUPS),
    canAccessDeviceGroups: isAdmin || hasModuleAccess(roles, Module.DEVICE_GROUPS),
    canAccessGroups, // Can see Groups menu with either group permission
    canAccessAuditLogs: isAdmin || !onlyAdminAccessLogs || hasModuleAccess(roles, Module.AUDIT_LOGS),
    canAccessStrategies: isAdmin || hasModuleAccess(roles, Module.STRATEGIES),
    canAccessRoles,
    canAccessControlRoles: isAdmin || hasModuleAccess(roles, Module.CONTROL_ROLES),
    canAccessCustomClients: isAdmin || hasModuleAccess(roles, Module.CUSTOM_CLIENTS),
  };
}
